import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageDynamicDisplay } from '../components/ImageDisplay';

export type UploadStatus = 'pending' | 'uploading' | 'completed' | 'error';

export interface CustomImageAttributes {
  src: string;
  alt?: string;
  title?: string;
  id?: string;
  uploadStatus?: UploadStatus;
  progress?: number;
}

export const CustomImage = Image.extend({
  name: 'image',
  addAttributes() {
    return {
      ...this.parent?.(),
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-id'),
        renderHTML: attributes => {
          if (!attributes.id) {
            return {};
          }
          return { 'data-id': attributes.id };
        },
      },
      uploadStatus: {
        default: 'completed',
        parseHTML: element => element.getAttribute('data-upload-status') || 'completed',
        renderHTML: attributes => {
          if (!attributes.uploadStatus || attributes.uploadStatus === 'completed') {
            return {};
          }
          return { 'data-upload-status': attributes.uploadStatus };
        },
      },
      progress: {
        default: 100,
        parseHTML: element => {
          const progress = element.getAttribute('data-progress');
          return progress ? parseInt(progress, 10) : 100;
        },
        renderHTML: attributes => {
          if (attributes.progress === 100) {
            return {};
          }
          return { 'data-progress': attributes.progress };
        },
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageDynamicDisplay);
  },
});

export default CustomImage;
